export const directoryData = [
    {
        name: "Jones",
        image: "/jones.png",
        // give a correct format for timestamp so it can be sorted by
        dateJoined: new Date("2020-01-15").toISOString(),

        familyMembers: [
            {
                name: "John Jones",
                phone: "(123) 456-7890",
                email: "john@mail.com",
                bio: "Loves hiking and outdoor adventures."
            },
            {
                name: "Jane Jones",
                phone: "(123) 456-7891",
                email: "jane@mail.com",
                bio: "Enjoys painting and art galleries."
            },
            {
                name: "Jimmy Jones",
                bio: "Avid reader and chess enthusiast."
            }
        ]
    },
    {
        name: "Smith",
        image: "/gallagher.png",
        dateJoined: new Date("2019-11-30").toISOString(),
        familyMembers: [
            {
                name: "Tom Smith",
                phone: "(555) 987-6543",
                email: "tom@mail.com",
                bio: "Loves cooking and trying new recipes."
            },
            {
                name: "Linda Smith",
                phone: "(555) 987-6544",
                email: "linda@mail.com",
                bio: "Enjoys gardening and nature walks."
            },  
            {
                name: "Bobby Smith",
                bio: "Basketball player and sports fan."
            }
        ]   

    },
     {
        name: "Perez",
        image: "/smith.png",
        dateJoined: new Date("2022-03-10").toISOString(),
        familyMembers: [
            {
                name: "Robert Perez",
                phone: "(987) 654-3210",
                email: "bob@mail.com",
                bio: "Guitarist in a local band."
            },
            {
                name: "Emily Perez",
                phone: "(987) 654-3211",
                email: "emily@mail.com",
                bio: "Yoga instructor and wellness coach."
            },
            {
                name: "Sophie Perez",
                bio: "Loves baking and trying new recipes."
            }
        ]
    }, 
    
    {
        name: "Davis",
        image: "/star.png",
        dateJoined:  new Date("2021-06-20").toISOString(),
        familyMembers: [    
            {
                name: "Michael Davis",
                phone: "(555) 123-4567",
                email: "michael@mail.com",
                bio: "Tech enthusiast and blogger."
            },
            {
                name: "Sarah Davis",
                phone: "(555) 123-4568",
                email: "sarah@mail.com",
                bio: "Passionate about photography and travel."
            },  
            {
                name: "Liam Davis",
                bio: "Soccer player and sports fan."
            }
        ]
    }, 
]


export const prayerRequestData = [
    {
        id: 1,
        name: "Christian Jones",
        initials: "CJ",
        praying: false,
        avatarBg: "#FF5733",
        content: "Hello Church I need prayers for my grand father who is recently been admitted to the hospital.",
        comments: [
            { id: 1, user: "David Smith", text: "Praying for your grandfather's swift recovery!" },
            { id: 2, user: "Rebecca Steinhart", text: "May God bless and heal him." }
        ]
    },
        
    {
        id: 2,
        name: "David Smith",
        initials: "DS",
        praying: true,
        avatarBg: "#33C3FF",
        content: "Please keep me in prayer as I prepare for an important job interview tomorrow. I'm feeling nervous but trusting God's plan.",
        comments: [
            { id: 1, user: "Christian Jones", text: "You'll do great! Trust in God." }, 
            { id: 2, user: "Claudia Mendes", text: "Sending positive vibes your way!" }
        ]
    },
    {
        id: 3,
        name: "Rebecca Steinhart",
        initials: "RS",
        praying: false,
        avatarBg: "#8D33FF",
        content: "I am facing some challenges at work and would appreciate prayers for guidance and strength.",
        comments: [
            { id: 1, user: "David Smith", text: "Stay strong, Rebecca. Praying for clarity and peace." },
            { id: 2, user: "Claudia Mendes", text: "You've got this! Trust in God's plan." }
        ]
    },
    {
        id: 4,
        name: "Claudia Mendes",
        initials: "CM",
        praying: false,
        avatarBg: "#33FF57",
        content: "My family is going through a tough time right now. Please pray for unity and understanding among us.",
        comments: [
            { id: 1, user: "Christian Jones", text: "Family is everything. Praying for healing and love." },
            { id: 2, user: "Rebecca Steinhart", text: "May God bring peace to your family." }
        ]
    }

]